module.exports = __webpack_public_path__ + "img/icon_exclamation.b0d7918f.png";